export const selectStateDetails = (state) => {
	// Refactor this to a cleaner method
	const currentState = {
		...state?.stateData?.currentState,
		meta: {
			...state?.stateData?.currentState.meta,
			canonical: `${state.app.baseUrl}/${state?.stateData?.currentState.stateUrl}`
		}
	};

	return currentState;
};
